module.exports = __webpack_public_path__ + "static/media/20220801_173326.667b11d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/20220801_173326.mp3
// module id = +3b/
// module chunks = 1